<template>
  <div class="dashboard-notification">
    <p class="dashboard-notification__desc">
      あなたの楽曲を世界中に配信しましょう。今なら月額660円が3ヶ月無料です‼<br>
      楽曲の登録手順については、よくある質問「
      <router-link
        :to="{ name : 'faq-detail', params: {id: 89} }"
        class="c-text-link">
        リリース登録の手順を教えてください。
      </router-link>」をご確認ください。
    </p>
  </div>
</template>

<script>

export default {
  name: 'DashboardNotification',
}
</script>
